import classNames from "classnames";
import React from "react";
import { actions } from "react-redux-form";
import { Dispatch } from "redux";

import { Errors, RadioButton } from "../../../../core/atoms/rrf";
import { CommonProps, EnquiryFormSection } from "./common";
import { FormProgressIcon } from "./formProgressIcon";

interface OwnProps {
  dispatch: Dispatch<IWebStoreState>;
}

export class PlanningStageSelect extends EnquiryFormSection<OwnProps> {
  protected shouldUpdateValidity(oldProps: CommonProps, newProps: CommonProps) {
    return oldProps.formState.planningStage != newProps.formState.planningStage;
  }

  protected syncValidity(formState: Forms.EnquiryForm) {
    this.props.dispatch(actions.setErrors(this.props.model, { required: formState.planningStage == null }));
  }

  public render() {
    const { model, className, id, formState } = this.props;
    const locationName = formState.location ? formState.location.name : null;

    return (
      <section id={id} className={classNames("planning-stage-select", className)}>
        <header>
          <FormProgressIcon model={model} />
          <h2>How much planning have you done already?</h2>
        </header>

        <div className="enquiry-form-question enquiry-form-radio-select">
          <Errors model={model} messages={{ required: "Please select an option" }} />

          <RadioButton
            model={model}
            id={`planning-stage-${PlanningStage.InitialResearch}`}
            value={PlanningStage.InitialResearch}
            label="I'm just researching"
            subLabel={`I've yet to fully decide if I’m going to visit ${locationName || "my destination"}`}
            getValue={e => parseInt((e as React.ChangeEvent<HTMLInputElement>).target.value)}
          />

          <RadioButton
            model={model}
            id={`planning-stage-${PlanningStage.MoreAdvice}`}
            value={PlanningStage.MoreAdvice}
            label={`I definitely want to go to ${locationName || "my destination"}`}
            subLabel="I want to start planning my trip, but need help narrowing down my options"
            getValue={e => parseInt((e as React.ChangeEvent<HTMLInputElement>).target.value)}
          />

          <RadioButton
            model={model}
            id={`planning-stage-${PlanningStage.ReadyToBook}`}
            value={PlanningStage.ReadyToBook}
            label="I'm ready to book"
            subLabel="I know more or less what I want to do, and I'm keen to finalise my plans"
            getValue={e => parseInt((e as React.ChangeEvent<HTMLInputElement>).target.value)}
          />
        </div>
      </section>
    );
  }
}
